<template>
<div>
    <v-card flat outlined v-if="loaded">
        <v-card-text>            
            <v-row class="mt-4" no-gutters>
                <template v-for="(item, index) in items">
                    <v-col cols="12" sm="6" :key="item.uid">
                        <v-card flat class="pa-2 transparent" @click="goTo(item)" style="cursor:pointer">
                            <div class="d-flex align-center" :class="(index>1) ? 'mt-6' : 'mt-2'">
                                <div  class="mr-6">
                                    <UserAvatar :photo="item.photo" size="90" class="elevation-2"/>
                                </div>
                                <div>
                                    <div class="headline font-weight-light black--text" @click="goTo(item)" style="cursor:pointer">{{item.name}}</div>
                                    <div class="mt-n1 grey--text text--darken-3 d-flex align-center">
                                        <v-icon size="10px" color="primary" class="mr-1 mt-1">fa-envelope</v-icon>
                                        <div>{{item.email}}</div>
                                    </div>
                                    <!-- AWARDS -->
                                    <div class="d-flex align-center mt-2" v-if="item.awards">
                                        <div v-for="aw in item.awardsList" :key="aw.id" class="mr-2">
                                            <v-img :src="require('@/assets/awards/' + aw + '.png')" width="24px"></v-img>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                    <v-responsive
                        v-if="item === 2"
                        :key="`width-${item}`"
                        width="100%"
                    ></v-responsive>
                </template>
            </v-row>
        </v-card-text>
    </v-card>

    <SendingLoader v-else/>
</div>  
</template>

<script>

export default {
    data: () => ({
        loaded: false
    }),
    props: ['items'],
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.items.forEach(dt => {
                if (dt.awards) {
                    let tempo = [];
                    for (let key in dt.awards) {
                        tempo.push(key)
                    }
                    dt.awardsList = tempo;
                }
            });
            this.loaded = true;
        },
        goTo(item) {
            if (item.uid === this.user.uid) {
                this.$router.push('/my-profile/')
            } else {
                this.$router.push('/profile/'+item.uid)
            }
        }
    }
}
</script>